import { createGlobalStyle, css, keyframes } from 'styled-components';
import { fontStyle } from 'src/assets/fonts/fonts';
import logoSrc from 'src/assets/prisma-logo-short-colored.svg';
import {
  LayoutFooter,
  LayoutHeader,
  LayoutMain,
} from 'src/components/layout/layout';
import { cn } from 'src/utils/cn';

// eslint-disable-next-line no-restricted-syntax
export enum Colors {
  brand = '#00378b',
  brandLight1 = '#4069a8',
  /**
   * Used for placeholder and empty style color.
   */
  brandLight2 = '#809bc5',
  brandLight3 = '#c6e4f2',
  brandLight4 = '#deedf7',
  brandLight5 = '#f7fafd',
  brandSkyBlue = '#56a7d8',
  brandSecondary = '#ce2f87',
  brandBorder = '#cce4f3',
  error = '#ea1313',
  errorLight = '#ffa8a8',
  errorLighter = '#fff6f6',
  errorDark = '#E41111',
  inactive = '#8d9093',
  inactiveLight = '#e5e5e5',
  inactiveLighter = '#f9f9f9',
  ready = '#0ebfcb',
  readyLight = '#a6e7ec',
  success = '#00c878',
  successLight = '#a1ebcd',
  warning = '#ffbe1e',
  warningLight = '#fff8e4',
  background = '#ebf2fb',
}

export const flyoutStyles = css`
  background-clip: padding-box;
  border-radius: 0.4rem;
  background-color: #fff;
  box-shadow: 0 0.3rem 0.6rem #00378b33;
`;

export const flyoutClasses = cn(`
  rounded-xs bg-white bg-clip-padding shadow-elevation-sm
  legacy:rounded-[0.4rem] legacy:shadow-[0_0.3rem_0.6rem_#00378b33]
`);

// eslint-disable-next-line no-restricted-syntax
export enum Breakpoints {
  minTablet = 'min-width: 768px',
  minDesktop = 'min-width: 992px',
  minWideDesktop = 'min-width: 1200px',
}

export const GlobalStyle = createGlobalStyle`
  ${fontStyle};

  html {
    /* avoid layout jumping, because of scroll bars */
    /* but only on bigger screens to avoid non-centered content */
    /* https://stackoverflow.com/a/44000322/1337972 */
    @media (${Breakpoints.minTablet}) {
      width: 100vw;
      overflow-x: hidden;
    }
  }


  ${
    process.env.NODE_ENV === 'test' &&
    css`
      * {
        transition: none !important;
        animation: none !important;
      }
    `
  };
`;

export const PrintStyle = createGlobalStyle`
  @media print {
    @page {
      margin-top: 1em;
      margin-bottom: 1em;
    }

    ${LayoutHeader}, ${LayoutFooter} {
      display: none;
    }

    /* Logo in top-right corner */
    ${LayoutMain}::before {
      content: url("${logoSrc}");
      position: absolute;
      top: 0.5em;
      right: 0.5em;
      width: 8em;
      height: auto;
      z-index: 10;
    }

    ${LayoutMain} {
      width: 100%;
      box-sizing: border-box;
      margin-top: 1em;
      page-break-inside: avoid;
    }
  }
`;

export const rotateKeyframes = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const rotateAnimationDurationInMS = 800;

export const rotateAnimation = css`
  animation: ${rotateKeyframes} ${rotateAnimationDurationInMS}ms linear infinite;
`;

export const focusWithinClasses = cn(
  `
    not-legacy:focus-within:outline-2 not-legacy:focus-within:-outline-offset-2
    not-legacy:focus-within:outline-foreground-support-highlight
    legacy:focus-within:legacy-focus-style
  `
);
